export const TABLE_ID = 'user_profile_history_portfolio_data_table'

export const LOCALE_PREFIX = 'components.Dialog.components.UserProfile.components.Content.components.HistoryPortfolio'
